import { useTranslation } from 'react-i18next'
import { CycleBasicsFields } from './CycleBasicsFields'
import type { CycleBasicsDraft, CycleBasicsErrors } from './reviewUtils'

/**
 * The "Next" step of a one-cycle space (F-48 criterion 1): the cycle's title,
 * period and window. The cycle is created as a draft right after the space,
 * and the person lands in its editor (model, questions, audience, opening).
 */
export const CycleSingleStep = ({ draft, onChange, errors, disabled = false }: {
  draft: CycleBasicsDraft
  onChange: (draft: CycleBasicsDraft) => void
  errors?: CycleBasicsErrors | null
  disabled?: boolean
}) => {
  const { t } = useTranslation('performanceReview')
  return (
    <div className="min-w-0 space-y-5" data-testid="review-cycle-single-step">
      <div className="space-y-1">
        <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-900">{t('wizard.step')}</h3>
        <p className="text-xs text-gray-500">{t('wizard.stepHint')}</p>
      </div>
      <CycleBasicsFields draft={draft} onChange={onChange} errors={errors} disabled={disabled} idPrefix="wizard-cycle" />
      <p className="text-xs text-gray-500">{t('wizard.bornDraft')}</p>
    </div>
  )
}
